import { gql } from '@apollo/client';

export const METERS_REQUIRING_ESTIMATES = gql`
  query GetMeters($month_year: String!) {
    metersRequiringEstimates(month_year: $month_year) {
      groupKey
      meters {
        meterId
        meterNumber
        name
        lastMonth
        lastMonthMeterReadType
        estimate
        factor
        booked
        comment
        percentChange
        approvalStatus
        isManualOverride
      }
    }
  }
`;

export const SAVE_ESTIMATE_BOOKINGS = gql`
  mutation SaveEstimateBookings($updates: [EstimateBookingInput!]!) {
    saveEstimateBookings(updates: $updates) {
      success
      message
      results {
        meterId
        success
        error
      }
    }
  }
`;
